import { CLAIM_STAGES } from '@shared/lib/statusLabels';

export const PAGE_SIZE = 25;

export const TYPE_OPTIONS = [
  { value: '', label: 'Все типы' },
  { value: 'claim', label: 'Претензия' },
  { value: 'lawsuit', label: 'Иск' },
];

export const DIRECTION_OPTIONS = [
  { value: '', label: 'Любое направление' },
  { value: 'incoming', label: 'Входящие' },
  { value: 'outgoing', label: 'Исходящие' },
];

export const STAGE_OPTIONS = [
  { value: '', label: 'Все стадии' },
  ...CLAIM_STAGES,
];

export const SORT_OPTIONS = [
  { value: 'created_at', label: 'По дате' },
  { value: 'counterparty', label: 'По контрагенту' },
  { value: 'amount', label: 'По сумме' },
  { value: 'stage', label: 'По стадии' },
];
